/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Observable, of, timer} from 'rxjs';
import {filter, tap} from 'rxjs/operators';

/**
 * Caching decorator
 * @param cacheMaxAge Maximum amount of time a function can be cached, in milliseconds
 */
// TODO: Add a way to exclude function parameters from the cache map key generator
//      See the following link for more information: https://stackoverflow.com/a/52776537
export function Cacheable(cacheMaxAge: number = 300000): Function {
    return function (target: any, name: string, descriptor: PropertyDescriptor): void {
        const cache = new Map<string, any>();
        const method = descriptor.value;
        descriptor.value = function (...args: any): Observable<any> {
            const key = JSON.stringify(args);

            if (cache.has(key)) {
                return of(cache.get(key));
            }

            return method.apply(this, args).pipe(
                    tap(response => {
                        cache.set(key, response);

                        timer(cacheMaxAge).pipe(
                                filter(() => cache.has(key))
                        ).subscribe(() => {
                            cache.delete(key);
                        });
                    })
            );
        };
    };
}
